import React from 'react';
import Cta from '../components/Cta';
import Footer from '../components/Footer';
import Hero from '../components/Hero';
import Intro from '../components/Intro';
import Services from '../components/Services';
import Metodologie from '../components/Metodologie';
import Want from '../components/Want';


const Home = () => {
    return (
        <>
            <Hero />
            <Intro />
            <Want/>
            <Metodologie/>
            <Services />
            <Cta/>
            <Footer />
        </>

    )
}

export default Home;

